import { Product } from "@/types";
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDate(date?: string | Date | null): string {
  if (!date) {
    return "-";
  }

  let value = date;

  if (typeof value === "string" || typeof value === "number") {
    value = new Date(date);
  }

  return new Intl.DateTimeFormat("en-US", { dateStyle: "medium" }).format(
    value
  );
}

export function getCurrencySymbol(currency: string) {
  const symbols: Record<string, string> = {
    usd: "$",
    eur: "€",
    pen: "S/",
  };

  return symbols[currency.toLowerCase()] || currency.toUpperCase();
}

export function getProductState(product: Product, t: (key: string) => string) {
  const stateKeys: Record<string, string> = {
    new_sealed: "new_sealed",
    new_complete: "new_complete",
    pre_owned: "pre_owned",
    pre_owned_with_box: "pre_owned_with_box",
  };

  return t(`shared.product_states.${stateKeys[product.state] ?? "unknown"}`);
}

export function getProductTypeLabel(
  productType: string,
  t: (key: string) => string
) {
  return t(`shared.product_types.${productType}`);
}

export function getBaseUrl() {
  return import.meta.env.MODE === "development"
    ? "brickgestor.local:3100"
    : "brickgestor.app";
}

export function getStoreUrl(subdomain: string): string {
  return `//${subdomain}.${getBaseUrl()}`;
}

export function getStoreDomain(subdomain: string): string {
  return `${subdomain}.${getBaseUrl()}`;
}
